import React, { useState, useEffect } from 'react';
import Tools from '../../Tools';
import Popover from '../../ui/Popover';


const DocsVespucioSur = (props) => {

    const [selectedAllDocs, setSelectedAllDocs] = useState(true);
    const [loading, setLoading] = useState({ client: false, campaign: false, tasks: false, documents: false, patent: false });
    const [error, setError] = useState(false);
    const [documentId, setDocumentId] = useState(null);

    const toggleAllDebts = () => {
        setSelectedAllDocs(!selectedAllDocs); //variable to toggle
        if (selectedAllDocs) {
            props.documents.forEach(d => { d.selected = false; });
            props.setDebtFn(0);
        } else {
            props.documents.forEach(d => { d.selected = true; });
            props.setDebtFn(props.documents.reduce((a, b) => { return a + Number(b.montoDocto); }, 0));
        }
    }

    const selectDebt = (event, doc) => {
        if (!event.target.checked) {
            doc.selected = false;
            props.setDebtFn(props.debt - Number(event.target.value));
        } else {
            doc.selected = true;
            props.setDebtFn(props.debt + Number(event.target.value));
        }
    }

    useEffect(() => {
        const totalDebt = props.documents.reduce((a, b) => { return a + Number(b.montoDocto); }, 0);
        props.setDebtFn(totalDebt);
    }, [props.documents]);

    return (
        <table className="fullWidth">
            <thead>
                <tr>
                    <th><input type="checkbox" onChange={toggleAllDebts} defaultChecked={true} /> &nbsp; Cod Cliente</th>
                    <th className='center'>Nº Documento</th>
                    <th className='center'>Tipo Documento</th>
                    <th className='center'>Vencimiento</th>
                    <th className='right'>Monto docto</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                {props.documents.map((doc, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                <label className="forCheckbox"><input type="checkbox" name={'ckeck' + index} value={doc.montoDocto} onChange={(e) => selectDebt(e, doc)} checked={doc.selected} defaultChecked={true} />{props.clientCode}</label>
                            </td>
                            <td className="center">{doc.numDocto}</td>
                            <td className="center">{doc.tipoDocto}</td>
                            <td className="center">{Tools.fdCL(doc.fecVcto)}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.montoDocto)}</td>
                            <td className="rel">
                                {doc.patente?(<>
                                <a onClick={() => (doc.numDocto === documentId)?setDocumentId(null):setDocumentId(doc.numDocto)}><i className='info'/></a>
                                <Popover show={doc.numDocto === documentId}>
                                    <div className="header">Información de patente asociada</div>
                                    <dl>
                                        <dt>Patente</dt>
                                        <dd>{doc.patente}</dd>
                                        <dt>Nro. Tag</dt>
                                        <dd>{doc.tag}</dd>
                                    </dl>
                                </Popover></>
                                ):(
                                    <i className='info disabled'/>
                                )}
                            </td>
                        </tr>

                    );
                })}
            </tbody>
        </table>
    );

}

export default DocsVespucioSur;